import type {ReactAction} from '@netx/core/bootstrap';
import {faList} from '@netx/core-icons';
import {isMobile} from '@netx/core-next/utils/browser';
import {canQuickEdit} from '@netx/core-attribute-quick-edit/enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';

/**
 * Edit cart asset attribute values
 * @param params
 * @returns Action
 */
export const cartActionBulkEditAttributes = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'current-cart-bulk-edit-attributes',
	cb: () => dispatcher.trigger('asset:quickedit'),
	enableTest: () => isMobile(false) && canQuickEdit(),
	icon: faList,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EDIT_ATTRIBUTES;
	},
	...params,
});

export default cartActionBulkEditAttributes;
